// packages/icons/src/library/arrow-left.tsx
import { Path, SVG } from "@wordpress/primitives";
import { jsx } from "react/jsx-runtime";
var arrow_left_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M20 11.2H6.8l3.7-3.7-1-1L3.9 12l5.6 5.5 1-1-3.7-3.7H20z" }) });
export {
  arrow_left_default as default
};
//# sourceMappingURL=arrow-left.mjs.map
